import { useCallback, useState } from "react";
import { H1, P, Span } from "../../../../components/Text/Text";
import Icon from "../../../../components/Icon/Icon";
import Button from "../../../../components/Button/Button";
import { useNavigate } from "react-router";
import { RoutesE } from "../../../../routes/routesData";
import { IconColorE } from "../../../../models/enums";
import { copyText } from "../../../../utils/helpers/copyText";
import bgImage from "../../../../assets/images/sentToBroadcaster.svg";

import styles from "./styles.module.scss";

interface RegistrationCompletedI {
  clientData: {
    clientType: string;
    clientName: string;
    userName: string;
    password: string;
  };
}

const RegistrationCompleted = ({ clientData }: RegistrationCompletedI) => {
  const [isPasswordShown, setIsPasswordShown] = useState(false);
  const navigate = useNavigate();

  const togglePasswordShown = () => {
    setIsPasswordShown((prev) => !prev);
  };

  const handleNavigateToLogin = useCallback(() => {
    navigate(RoutesE.LOGIN);
  }, [navigate]);

  const handleCopyPassword = () => {
    copyText(clientData.password);
  };

  return (
    <div className={styles.wrapper}>
      <img
        src={bgImage}
        title="Account created successfully"
        alt="Account created successfully"
        className={styles.topImage}
      />
      <H1>Account created successfully</H1>
      <P>Your new account and user were created successfully.</P>
      <ul>
        <li>
          <Span>Client type</Span>:<span>{clientData.clientType}</span>
        </li>
        <li>
          <Span>Client name</Span>:<span>{clientData.clientName}</span>
        </li>
        <li>
          <Span>User name</Span>:<span>{clientData.userName}</span>
        </li>
        <li>
          <Span>Password</Span>:
          <span>
            {clientData.password
              ?.split("")
              ?.map((letter) => (isPasswordShown ? letter : "*"))}
          </span>
          <div
            onClick={togglePasswordShown}
            className={styles.passwordIconWrapper}
          >
            <Icon
              name={isPasswordShown ? "eyeClosed" : "eye"}
              title={isPasswordShown ? "Hide password" : "Show password"}
              color={IconColorE.GRAY}
            />
          </div>
          <div onClick={handleCopyPassword} className={styles.copyIconWrapper}>
            <Icon name="copy" color={IconColorE.BLUE} title="Copy password" />
          </div>
        </li>
      </ul>
      <Button onClick={handleNavigateToLogin}>Login</Button>
    </div>
  );
};

export default RegistrationCompleted;
